import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
    palette: {
    type: 'dark',
    },
});